<template>
  <Block type="gradient">
    <DashboardBlock
      :primary="false"
      img="/icon/borrow-apr-v2.png"
      title="Borrow APR"
      :amount="`${borrowAprFormatted}%`"
    />
    <DashboardBlock
      :primary="false"
      img="/icon/lending-v2.png"
      title="Lending Pool Utilized"
      :amount="`${lendingPoolUtilizedFormatted} ${nativeCurrencySymbol}`"
    />
    <!-- <Button text="New Loan" secondary small class="mt-2" /> -->
    <Button
      :text="`Buy ${tokenSymbol || 'HYPE'}`"
      type="link"
      :link="dexBuyLink"
      primary
      small
      class="w-full"
    />
  </Block>
</template>

<script>
import { mapGetters } from "vuex";
import Block from "./Block.vue";
import DashboardBlock from "../dashboard/DashboardBlock.vue";
import Button from "./Button.vue";
export default {
  name: "PoolAvailable",
  components: {
    Block,
    DashboardBlock,
    Button,
  },
  computed: {
    ...mapGetters([
      "borrowAprFormatted",
      "dexBuyLink",
      "lendingPoolUtilizedFormatted",
      "nativeCurrencySymbol",
      "tokenSymbol",
    ]),
  },
};
</script>
